import React, { Fragment, useEffect, useState } from "react";
import { cdnImg } from "../../Utils/cdnImage";
import { apiGet } from "../../Utils/apiFetch";
import apiPath from "../../Utils/apiPath";
import { isEmpty } from "lodash";
const OpenBets = ({ setShowBets }) => {
  const [data, setData] = useState([]);
  const [betInfo, setBetInfo] = useState(false);
  const [single, setSingle] = useState({});
  const getBets = async () => {
    const { status, data: response_users } = await apiGet(
      apiPath.mobileCurrentBets,
    );

    if (response_users.success) {
      setData(response_users?.results);
    }
  };

  useEffect(() => {
    getBets();
  }, []);

  const BetsList = ({ bets }) => {
    // Group bets into back/lay
    const grouped = bets.reduce((acc, bet) => {
      const type = !isEmpty(bet?.betType)
        ? bet?.betType
        : bet?.type == "No"
          ? "lay"
          : "back"; // back / lay
      acc[type] = acc[type] || [];
      acc[type].push(bet);
      return acc;
    }, {});

    return (
      <div id="txnList" className="slip-list" style={{ display: "block" }}>
        {Object.entries(grouped).map(([sideType, sideBets]) => (
          <React.Fragment key={sideType}>
            {/* Header */}
            <dl id={`header_${sideType}`} className="bets-head">
              <dt>
                <h4>{sideType.charAt(0).toUpperCase() + sideType.slice(1)}</h4>
              </dt>
              <dd className="col-odds">
                <span>Odds</span>
              </dd>
              <dd className="col-stake">
                <span>Stake</span>
              </dd>
              <dd className="col-profit">
                <span>{sideType === "lay" ? "Liability" : "Profit"}</span>
              </dd>
            </dl>

            {/* Bets */}
            {sideBets.map((bet) => (
              <dl
                key={bet._id}
                id={`txn_${bet._id}`}
                className={`bets-${sideType}`}
                style={{ display: "flex" }}
              >
                <dt>
                  <span id="sideType" className={sideType}>
                    {["No", "Yes"].includes(bet?.type)
                      ? bet?.type
                      : sideType.charAt(0).toUpperCase() + sideType.slice(1)}
                  </span>
                  <h4 id="selectionName">{bet?.teamName || bet?.fancyName}</h4>
                </dt>

                <dd id="odds" className="col-odds">
                  <span>{bet.bhav}</span>
                </dd>

                <dd id="stake" className="col-stake" title={bet.amount}>
                  <span>{bet.amount}</span>
                </dd>

                <dd id="pl" className="col-profit">
                  <span>
                    {sideType === "lay" ? bet.loseAmount : bet.profitAmount}
                  </span>
                </dd>

                <dd
                  id="betInfo"
                  className="col-ref"
                  style={{ display: betInfo ? "block" : "none" }}
                >
                  <ul>
                    <li id="betId">{bet.matchBetId}</li>
                    <li id="placeDate">
                      {new Date(bet.timeInserted).toLocaleString()}
                    </li>
                  </ul>
                </dd>
              </dl>
            ))}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <div
      id="openBetsLeftSide"
      className="overlay left-side"
      style={{ display: "block" }}
    >
      <div id="openBetSlide" className="side-wrap" style={{ display: "flex" }}>
        <div id="sideHead" className="side-head">
          <h3 className="a-open_bets">
            <img src={cdnImg("assets/images/transparent.gif")} />
            Open Bets
          </h3>
          <div
            onClick={() => setShowBets(false)}
            id="close"
            className="close"
          />
        </div>
        <div id="sideContent" className="side-content">
          {isEmpty(single) ? (
            <ul id="eventMenuList" className="menu-list">
              {data?.map((res) => {
                return (
                  <Fragment>
                    {res?.betList?.length > 0 && (
                      <li
                        className={`inplay-${
                          res?.status == "in_play" ? "on" : "off"
                        }`}
                        style={{ display: "list-item" }}
                      >
                        <div
                          className="menu-list-a"
                          onClick={() => {
                            setSingle({
                              type: "Match Odds",
                              bets: res?.betList,
                              eventName: res?.eventName,
                            });
                          }}
                        >
                          <p>{res?.eventName} - Match Odds</p>
                        </div>
                      </li>
                    )}{" "}
                    {res?.bookmakerList?.length > 0 && (
                      <li
                        className={`inplay-${
                          res?.status == "in_play" ? "on" : "off"
                        }`}
                        style={{ display: "list-item" }}
                      >
                        <div
                          className="menu-list-a"
                          onClick={() => {
                            setSingle({
                              type: "Bookmaker",
                              bets: res?.bookmakerList,
                              eventName: res?.eventName,
                            });
                          }}
                        >
                          <p>{res?.eventName} - Bookmaker</p>
                        </div>
                      </li>
                    )}{" "}
                    {res?.sessionBetList?.length > 0 && (
                      <li
                        className={`inplay-${
                          res?.status == "in_play" ? "on" : "off"
                        }`}
                        style={{ display: "list-item" }}
                      >
                        <div
                          className="menu-list-a"
                          onClick={() => {
                            setSingle({
                              type: "Fancy",
                              bets: res?.sessionBetList,
                              eventName: res?.eventName,
                            });
                          }}
                        >
                          <p>{res?.eventName} - Fancy</p>
                        </div>
                      </li>
                    )}{" "}
                    {res?.sportBookBetList?.length > 0 && (
                      <li
                        className={`inplay-${
                          res?.status == "in_play" ? "on" : "off"
                        }`}
                        style={{ display: "list-item" }}
                      >
                        <div
                          className="menu-list-a"
                          onClick={() => {
                            setSingle({
                              type: "SportBook",
                              bets: res?.sportBookBetList,
                              eventName: res?.eventName,
                            });
                          }}
                        >
                          <p>{res?.eventName} - Sportsbook</p>
                        </div>
                      </li>
                    )}
                  </Fragment>
                );
              })}
            </ul>
          ) : (
            <Fragment>
              <div
                id="pathWrap"
                className="path-wrap"
                style={{ display: "flex" }}
              >
                <div
                  onClick={() => setSingle({})}
                  id="goBack"
                  className="go_back"
                />
                <ul>
                  <li id="eventName">
                    {single?.eventName} - {single?.type}
                  </li>
                </ul>
              </div>
              <h3 id="txnHeader" style={{ display: "flex" }}>
                Matched
              </h3>
              <BetsList bets={single?.bets} />
              <ul
                id="openBetOption"
                className="check-list"
                style={{ display: "flex" }}
              >
                <li>
                  <div
                    id="showBetInfo"
                    className={betInfo ? "checked check-list" : "check-list"}
                    onClick={() => setBetInfo(!betInfo)}
                  >
                    Bet Info
                  </div>
                </li>
                <li>
                  <div id="showTimeOrder" className={"check-list"}>
                    Time Order
                  </div>
                </li>
              </ul>
            </Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default OpenBets;
